export default {"src":"/_next/static/media/ic_zcash_new.c17d2834.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};